import { render } from "./absence.vue?vue&type=template&id=5374fb7e&scoped=true"
import script from "./absence.vue?vue&type=script&lang=js"
export * from "./absence.vue?vue&type=script&lang=js"

import "./absence.vue?vue&type=style&index=0&id=5374fb7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5374fb7e"]])

export default __exports__